<ng-container [formGroup]="formData">
  <p-slider class="mu-slider" [step]="step" [formControlName]="controlName" [min]="min" [max]="max" (onSlideEnd)="slideEnd()"></p-slider>
</ng-container>
